import React from 'react';
import { NavLink } from 'react-router-dom';
import { SidebarShell, BrandMark, Button } from '@invested/ui';
import type { AuthUser } from '../../types';

interface MainLayoutProps {
  children: React.ReactNode;
  user: AuthUser | null;
  onLogout: () => void;
}

const NAV_LINKS = [
  { to: '/', label: 'Dashbord', end: true },
  { to: '/deltakere', label: 'Deltakere' },
  { to: '/provetaking', label: 'Prøveregistrering' },
  { to: '/forsendelser', label: 'Forsendelser' },
  { to: '/eksport', label: 'Eksport' },
];

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  [
    'block rounded-xl px-3 py-2 text-sm font-medium transition-colors',
    isActive
      ? 'bg-[color:var(--invested-bg-elevated-hover,rgb(255_255_255_/_0.10))] text-[color:var(--invested-text-primary,white)]'
      : 'text-[color:var(--invested-text-muted,rgb(255_255_255_/_0.65))] hover:bg-[color:var(--invested-bg-elevated,rgb(255_255_255_/_0.05))] hover:text-[color:var(--invested-text-primary,white)]',
  ].join(' ');

export const MainLayout: React.FC<MainLayoutProps> = ({ children, user, onLogout }) => {
  const sidebar = (
    <div className="flex h-full flex-col gap-6">
      <div className="px-2">
        <BrandMark size="sm" />
        <p className="mt-2 text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--invested-text-muted,rgb(255_255_255_/_0.5))]">
          dnam-ecrf
        </p>
        <p className="mt-1 text-xs text-[color:var(--invested-text-muted,rgb(255_255_255_/_0.45))]">
          DNAm-kalibreringsstudien
        </p>
      </div>
      <nav className="flex flex-1 flex-col gap-1">
        {NAV_LINKS.map((link) => (
          <NavLink key={link.to} to={link.to} end={link.end} className={navLinkClass}>
            {link.label}
          </NavLink>
        ))}
      </nav>
      {user && (
        <div className="space-y-2 border-t border-[color:var(--invested-border-subtle,rgb(255_255_255_/_0.08))] px-2 pt-4 text-xs text-[color:var(--invested-text-muted,rgb(255_255_255_/_0.55))]">
          {/* `name` defaults to the email address for accounts that never
              set a distinct display name (e.g. the bootstrap admin, whose
              invitation pre-fills `name` from `normalizeEmail(email)` —
              see backend/src/auth/invitationService.ts bootstrapFirstAdmin).
              Only render it as a second line when it's actually different
              from the email, so the sidebar doesn't show the same string
              twice. */}
          {user.name && user.name.trim().toLowerCase() !== user.email.trim().toLowerCase() && (
            <p className="truncate">{user.name}</p>
          )}
          <p className="truncate">{user.email}</p>
          <Button variant="ghost" size="sm" onClick={onLogout} className="w-full justify-start px-2">
            Logg ut
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <SidebarShell sidebar={sidebar} theme="light" ambient="none">
      <div className="mx-auto w-full max-w-6xl px-4 py-8 sm:px-6 lg:px-8">{children}</div>
    </SidebarShell>
  );
};

export default MainLayout;
